import styled from "styled-components";
import { IsAlbum } from "../../type/album";
import Card from "./Card";
import { useState } from "react";

interface IsCardList {
  currentDocs: IsAlbum[];
  currentUid: string;
  handlePrev: () => void;
  isPrivate?: boolean;
}
export default function CardList({
  currentDocs,
  currentUid,
  handlePrev,
  isPrivate,
}: IsCardList) {
  const [openIndex, setOpenIndex] = useState<number | undefined>();
  const onClickCard = (openIndex: number) => {
    setOpenIndex((prev) => (prev === openIndex ? undefined : openIndex));
  };

  return (
    <CardListWrap>
      {isPrivate
        ? currentDocs.map(
            (e: IsAlbum, i: number) =>
              !e.isVisible && (
                <Card
                  key={i}
                  index={i}
                  openIndex={openIndex}
                  onClick={() => onClickCard(i)}
                  id={e.id}
                  title={e.title}
                  url={e.url}
                  username={e.username || ""}
                  uid={e.uid}
                  currentUid={currentUid}
                  content={e.content}
                  vocalList={e.vocalList}
                  handlePrev={handlePrev}
                  platform={e.platform}
                />
              )
          )
        : currentDocs.map(
            (e: IsAlbum, i: number) =>
              e.isVisible && (
                <Card
                  key={i}
                  index={i}
                  openIndex={openIndex}
                  onClick={() => onClickCard(i)}
                  id={e.id}
                  title={e.title}
                  url={e.url}
                  username={e.username || ""}
                  uid={e.uid}
                  currentUid={currentUid}
                  content={e.content}
                  vocalList={e.vocalList}
                  handlePrev={handlePrev}
                  platform={e.platform}
                />
              )
          )}
    </CardListWrap>
  );
}

const CardListWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
